<template>
  <div class="footer-info-wrap">
    <div class="fix-width">
     <div class="footer-top-wrap">
      <IconWrap
        :width='283'
        :height='38'
        url='/static/homeIcon/footer-logo.png'
      ></IconWrap>
      <div class="footer-top-right-wrap">
        <span>技术支持：020-85211498（石牌）|020-39311499（大学城）|0757-86687823（南海）</span>
        <span>地址：广东省广州市天河区中山大道西55号 | 邮政编码：510631</span>
      </div>
     </div>
     <div class="middle-line"></div>
     <div class="footer-bottom-wrap">
      <span>华南师范大学 版权所有 粤ICP备05008875号</span>
      <span>广州奥凯信息咨询有限公司技术支持</span>
     </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
